export const careitIdTour = {
  tourKey: 'careit_id',
  conditions: {
    orgTypes: null,
    userTypes: null,
    plans: null,
  },
  steps: [
    {
      title: 'tours.careit-id.welcome.title',
      content: 'tours.careit-id.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="careit-id-header"]',
      title: 'tours.careit-id.header.title',
      content: 'tours.careit-id.header.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="careit-id-assignment-card"]',
      title: 'tours.careit-id.assignment-card.title',
      content: 'tours.careit-id.assignment-card.content',
      placement: 'top',
      showIf: () =>
        Boolean(
          document.querySelector('[data-tour="careit-id-assignment-card"]')
        ),
    },
    {
      target: '[data-tour="careit-id-pickup-address"]',
      title: 'tours.careit-id.pickup-address.title',
      content: 'tours.careit-id.pickup-address.content',
      placement: 'right',
      showIf: () =>
        Boolean(
          document.querySelector('[data-tour="careit-id-pickup-address"]')
        ),
    },
    {
      target: '[data-tour="careit-id-pickup-datetime"]',
      title: 'tours.careit-id.pickup-time.title',
      content: 'tours.careit-id.pickup-time.content',
      placement: 'right',
      showIf: () =>
        Boolean(
          document.querySelector('[data-tour="careit-id-pickup-datetime"]')
        ),
    },
    {
      target: '[data-tour="careit-id-created-by"]',
      title: 'tours.careit-id.created-by.title',
      content: 'tours.careit-id.created-by.content',
      placement: 'right',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="careit-id-created-by"]')),
    },
    {
      target: '[data-tour="careit-id-empty-state"]',
      title: 'tours.careit-id.empty-state.title',
      content: 'tours.careit-id.empty-state.content',
      placement: 'top',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="careit-id-empty-state"]')),
    },
  ],
};
